/**
 * Presentation Library Search Agent - Suggestions Section
 * Section 3: Suggestions for best performance
 */

import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { IN_PRESENTATION_SEARCH_PROMPT_KEYS } from './variables';

class PresentationLibrarySearchSuggestionsSection extends PromptSectionBase {
    protected readonly keywordsKey = IN_PRESENTATION_SEARCH_PROMPT_KEYS.suggestions;
    protected readonly fallbackContent = `## Best Practices

### Search Strategy
- Use semantic search for conceptual queries
- Use exact search when you know the specific text
- For visual similarity, provide a slideIndex or componentId as visualSource
- Prefer targeted scope first: use documentId/documentIds when you know likely sources
- Use documentId: "ALL" for cross-library ideation ("how have we done this before?")

### Result Selection
- Include all relevant result IDs - better to include more than miss important content
- Write detailed rationales explaining what you found and why it's relevant

### Avoiding Duplicate Results
When making multiple searches, use \`excludeAllPrevious: true\` to automatically exclude results you've already found:
\`\`\`json
{
  "documentId": "ALL",
  "searchType": "semantic",
  "resultTypes": ["slide", "component"],
  "query": "organizational structure",
  "excludeAllPrevious": true,
  "numResults": 10
}
\`\`\`
This ensures follow-up searches don't return the same slides/components you already found in this thread.

### Result Type Selection
- Use "slide" when looking for complete page results
- Use "component" for specific visual elements (charts, tables)
- Use "shape" when looking for individual text elements
- Use "layout" when looking for master templates`;
}

const suggestionsSection = new PresentationLibrarySearchSuggestionsSection();

/**
 * Get the suggestions section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getSuggestionsSection(): string {
    return suggestionsSection.getContent();
}

/**
 * Export constant for backwards compatibility
 */
export const IN_PRESENTATION_SUGGESTIONS = suggestionsSection.getFallbackContent();
